// apps/client/src/ui/screens/emotes.tsx (M0-T19, §8.7) — the emote wheel: eight round buttons on a 90 px circle around the screen
// centre, each labelled emotes.<id> with a small line glyph. Tapping one plays it (optimistically) and closes the wheel.
import { EMOTES, type EmoteId } from '@whiskerton/content';
import { useCommands } from '../../game/instance';
import { GLYPHS } from '../chat/emoteGlyphs';
import { useT } from '../i18n';
import { RoundButton } from '../kit';
import type { ScreenDef } from '../router';

declare module '../router' { interface ScreenParams { emotes: undefined } }

const RADIUS = 90;

function Emotes({ close }: { close: () => void }) {
  const t = useT();
  const cmd = useCommands();
  const play = (id: EmoteId) => { cmd.emote(id); close(); };
  return (
    <div style={{ position: 'absolute', inset: 0 }}>
      <div className="hit" style={{ position: 'absolute', inset: 0 }} onClick={close} />
      <div role="group" aria-label={t('chat.emotes')} style={{ position: 'absolute', left: '50%', top: '50%', width: 0, height: 0 }}>
        {EMOTES.map((id, i) => {
          const a = (i / EMOTES.length) * Math.PI * 2 - Math.PI / 2;
          return (
            <div key={id} data-emote={id} style={{ position: 'absolute', left: Math.cos(a) * RADIUS, top: Math.sin(a) * RADIUS, transform: 'translate(-50%, -50%)' }}>
              <RoundButton label={t(`emotes.${id}`)} onClick={() => play(id)}>{GLYPHS[id]}</RoundButton>
            </div>
          );
        })}
      </div>
    </div>
  );
}
export const screen: ScreenDef<'emotes'> = { id: 'emotes', layer: 'overlay', component: Emotes };
